import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const securityDepositDirectionStatusEnum = createEnum({
    NOT_STARTED: ['not_started', '未开始', 'default'],
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审批中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审批拒绝', 'red'],
    PENDING: ['pending', '待处理', 'orange'],
    PARTIAL: ['partial', '部分处理', 'blue'],
    COMPLETED: ['completed', '全部完成', 'cyan'],
    REJECTED: ['rejected', '处理拒绝', 'red'],
});
export const SECURITY_DEPOSIT_DIRECTION_STATUSES = enumValues(securityDepositDirectionStatusEnum);
export const SECURITY_DEPOSIT_DIRECTION_STATUS_LABEL_MAP = enumLabelMap(securityDepositDirectionStatusEnum);
export const securityDepositOperationStatusEnum = createEnum({
    REVIEWING: ['reviewing', '审批中', 'processing'],
    SETTLING: ['settling', '处理中', 'orange'],
    PARTIALLY_SETTLED: ['partially_settled', '部分完成', 'blue'],
    COMPLETED: ['completed', '全部完成', 'cyan'],
    REJECTED: ['rejected', '已拒绝', 'red'],
});
export const SECURITY_DEPOSIT_OPERATION_STATUSES = enumValues(securityDepositOperationStatusEnum);
export const SECURITY_DEPOSIT_OPERATION_STATUS_LABEL_MAP = enumLabelMap(securityDepositOperationStatusEnum);
export const securityDepositPaymentOperationTypeEnum = createEnum({
    PAYMENT: ['payment', '支付申请', 'blue'],
    RETURN_RECEIPT: ['return_receipt', '退回确认', 'green'],
});
export const SECURITY_DEPOSIT_PAYMENT_OPERATION_TYPES = enumValues(securityDepositPaymentOperationTypeEnum);
export const SECURITY_DEPOSIT_PAYMENT_OPERATION_TYPE_LABEL_MAP = enumLabelMap(securityDepositPaymentOperationTypeEnum);
export const securityDepositReceiptOperationTypeEnum = createEnum({
    RECEIPT: ['receipt', '入账确认', 'green'],
    RETURN_PAYMENT: ['return_payment', '退还申请', 'blue'],
});
export const SECURITY_DEPOSIT_RECEIPT_OPERATION_TYPES = enumValues(securityDepositReceiptOperationTypeEnum);
export const SECURITY_DEPOSIT_RECEIPT_OPERATION_TYPE_LABEL_MAP = enumLabelMap(securityDepositReceiptOperationTypeEnum);
export const securityDepositActionEnum = createEnum({
    DRAFT: ['draft', '保存草稿', 'default'],
    SUBMIT: ['submit', '提交', 'blue'],
});
export const SECURITY_DEPOSIT_ACTIONS = enumValues(securityDepositActionEnum);
export const SECURITY_DEPOSIT_ACTION_LABEL_MAP = enumLabelMap(securityDepositActionEnum);
//# sourceMappingURL=security-deposit.js.map